/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'navigation.global-shortcuts.all-sites': 'すべてのサイト',
  'navigation.global-shortcuts.apps.align': 'Align',
  'navigation.global-shortcuts.apps.analytics': 'アナリティクス',
  'navigation.global-shortcuts.apps.assets': 'アセット',
  'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
  'navigation.global-shortcuts.apps.company-hub': '会社ハブ',
  'navigation.global-shortcuts.apps.compass': 'Compass',
  'navigation.global-shortcuts.apps.confluence': 'Confluence',
  'navigation.global-shortcuts.apps.focus': 'Focus',
  'navigation.global-shortcuts.apps.goals': 'ゴール',
  'navigation.global-shortcuts.apps.home': 'ホーム',
  'navigation.global-shortcuts.apps.jira': 'Jira',
  'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
  'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
  'navigation.global-shortcuts.apps.loom': 'Loom',
  'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
  'navigation.global-shortcuts.apps.projects': 'プロジェクト',
  'navigation.global-shortcuts.apps.studio': 'スタジオ',
  'navigation.global-shortcuts.apps.talent': 'Talent',
  'navigation.global-shortcuts.apps.teams': 'チーム',
  'navigation.global-shortcuts.apps.trello': 'Trello',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': '閉じる',
  'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name} サイト',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(現在利用できません)',
  'navigation.global-shortcuts.menu-link-item.link-external-item-label': '外部リンクを開くアイコン',
  'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(読み込み中)',
  'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(読み込み中)',
  'navigation.global-shortcuts.shortcut-action.open-menu-label': 'メニューを開く',
  'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
  'navigation.global-shortcuts.sites': '{productName} 件のサイト',
};
